import { useContext } from 'react';
import { AppConfig } from 'react-app-env';
import { ConfigContext } from '@chr/navisphereonline-shared-components';

export const useAppConfig = () => {
  return useContext(ConfigContext) as AppConfig;
};